/**
 * RU on all settings including whitelisting
 * This is in common as all apps would need it
 * Setting Key value pairs come from db of the app.
 */
import { Entity } from '../common/base/entity/entity'
import { collectionSchemas, entitySchema, methodSchemas } from './mailServer.schema'
import { mailServerAction } from './mailServerAction'

class mailServerEntity extends Entity {
	// override the following if needed.
	// derived actionObj
	// derived Service obj
	// getActionFns if you want to suppress the baseActionobj methods
}

const fieldsMeta = {
	protocol: {
		label: 'Protocol',
		name: 'protocol',
		options: [{ label: 'IMAP', value: 'IMAP' }],
		type: 'select',
		required: true,
		default: 'IMAP',
		placeholder: 'Please select the protocol',
	},
	authType: {
		label: 'Auth Type',
		name: 'authType',
		options: [
			{ label: 'Password', value: 'password' },
			{ label: 'O Auth', value: 'oauth' },
		],
		type: 'select',
		required: true,
		default: 'password',
		placeholder: 'Please select the authType',
	},
	folderMapping: {
		label: 'Folder Mapping',
		name: 'folderMapping',
		type: 'multiSelect',
		options: [
			{ label: 'SuccessFolder', value: 'SuccessFolder'},
			{ label: 'failedFolder', value: 'failedFolder'},
			{ label: 'exclusionFolder', value: 'exclusionFolder'}
		],
		childFieldType: false,
		required: true,
		multiselect: true,
		placeholder: 'Please select the folderMapping',
	},
	caseFieldsMapping: {
		label: 'Case Fields Mapping',
		name: 'caseFieldsMapping',
		api: {
			path: 'ticketing/CaseField',
			method: 'GET',
		},
		type: 'multiSelect',
		required: true,
		multiselect: true,
		placeholder: 'Please select the caseFieldsMapping',
	},
	priorityMapping: {
		label: 'Priority Mapping',
		name: 'priorityMapping',
		type: 'multiSelect',
		options: [
			{ label: 'High Priority Email', value: 'high' },
			{ label: 'Low Priority Email', value: 'low' }
		],
		subOptions:[
			{
				"label": "Critical",
				"value": "Critical"
			}, {
				"label": "High",
				"value": "High"
			}, {
				"label": "Medium",
				"value": "Medium"
			}, {
				"label": "Low",
				"value": "Low"
			}, {
				"label": "Very low",
				"value": "Verylow"
			}
		],
		multiselect: true,
		childFieldType: true,
		required: true,
		placeholder: 'Please select the priorityMapping',
	},
	hostName: { label: 'Host/IP', name: 'hostName', type: 'text', required: true, placeholder: 'Please enter hostname or IP address' },
	portNo: { label: 'Port', name: 'portNo', type: 'text', placeholder: 'Default is 993', default: '993' },
	multiItem: {
		label: 'Enable Multi Item Types for Notes Processing',
		name: 'multiItem',
		type: 'select',
		default: false,
		placeholder: 'Process notes across multiple item types',
		options: [
			{ label: 'True', value: true },
			{ label: 'False', value: false },
		],
	},
	username: { label: 'UserName', name: 'username', type: 'text', required: true, placeholder: 'Please enter Username', readOnlyOnEdit: true },
	usernameUpdate: { label: 'UserName', name: 'username', type: 'text', required: true, placeholder: 'Please enter Username', disabled: true },
	password: { label: 'Password', name: 'password', type: 'password', placeholder: 'Please enter password', hideEval: '!authType || authType  === "oauth"' },
	redirectUri: {
		label: 'Redirect Uri',
		name: 'redirectUri',
		type: 'text',
		placeholder: 'Please enter redirectUri',
		hideEval: '!authType || authType  === "password"',
	},
	clientId: { label: 'Client Id', name: 'clientId', type: 'text', placeholder: 'Please enter clientId', hideEval: '!authType || authType  === "password"' },
	clientSecret: {
		label: 'Client Secret',
		name: 'clientSecret',
		type: 'password',
		placeholder: 'Please enter client Secret',
		hideEval: '!authType || authType  === "password"',
	},
	refreshToken: {
		label: 'Refresh Token',
		name: 'refreshToken',
		type: 'text',
		placeholder: 'Please enter refresh token',
		hideEval: '!authType || authType  === "password"',
	},
	tenantId: {
		label: 'Tenant Id',
		name: 'tenantId',
		type: 'text',
		placeholder: 'Please enter the registered application tenantId',
		hideEval: '!authType || authType  === "password"',
	},
	// successFolder: { label: 'SuccessFolder', name: 'successFolder', type: 'text', required: true, placeholder: 'Please enter successFolder', default: 'Pass' },
	// failedFolder: { label: 'FailedFolder', name: 'failedFolder', type: 'text', required: true, placeholder: 'Please enter failedFolder', default: 'Fail' },
	// reProcessFolder: { label: 'ReProcessFolder', name: 'reProcessFolder', type: 'text', required: false, placeholder: 'Please enter re Process folder' },
	// domain: { label: 'Domain', name: 'domain', type: 'text', required: true, placeholder: 'Please enter Issue Type' },
	// category: { label: 'Category', name: 'category', type: 'text', required: true, placeholder: 'Please enter category' },
	// subCategory: { label: 'SubCategory', name: 'subCategory', type: 'text', required: true, placeholder: 'Please enter Sub Category' },
	maxTryTicks: {
		label: 'Max Tries for Connecting',
		name: 'maxTryTicks',
		type: 'text',
		required: false,
		default: '5',
		placeholder: 'No of times to connect to notify and stop connecting. Default is 5',
	},
	skipTicks: {
		label: 'Skip Times',
		name: 'skipTicks',
		type: 'text',
		required: false,
		placeholder: 'Skip times, before trying logging again. Default is 10',
		default: '10',
	},
	moveToState: {
		label: 'MoveToState',
		name: 'moveToState',
		options: [
			{ label: 'Submitted', value: 'Submitted' },
			{ label: 'Resolved', value: 'Resolved' },
		],
		default: 'Submitted',
		type: 'select',
		required: true,
		placeholder: 'Please select ticket status',
	},
	// exclusionFolder: {
	// 	label: 'ExclusionMailsFolder',
	// 	name: 'exclusionFolder',
	// 	type: 'text',
	// 	required: true,
	// 	placeholder: 'Please enter exclusion mails folder',
	// 	default: 'Bulk',
	// },
	// team: {
	// 	label: 'Team',
	// 	required: true,
	// 	type: 'select',
	// 	name: 'team',
	// 	api: {
	// 		path: 'tenant/teams/getTeams',
	// 		method: 'GET',
	// 		limit: 20,
	// 		response: {
	// 			ref: 'data.teamNames',
	// 			labelKey: 'label',
	// 			valueKey: 'value',
	// 		},
	// 	},
	// 	// width: '10%',
	// },
	queueName: {
		label: 'Queue Name',
		required: true,
		type: 'select',
		name: 'queueName',
		api: {
			path: 'ticketing/queue',
			method: 'GET',
			filters: [
				{
					field: 'status',
					operator: 'is',
					value: 'Published',
				},
			],
			limit: 200,
			response: {
				ref: 'data',
				labelKey: 'queueName',
				valueKey: 'queueName',
			},
		},
		// width: '10%',
		readOnlyOnEdit: true,
	},
	allowedDomains: {
		label: 'Allowed Domains',
		required: true,
		type: 'select',
		name: 'allowedDomains',
		create: true,
		isMulti: true,
		promptMessage: 'Add Allowed Domain',
		placeholder: 'All domains allowed',
		modalMeta: [
			{
				name: 'allowedDomainsValue',
				label: 'Allowed Domains',
				type: 'monaco-editor',
				required: true,
				lang: 'html',
				dependsOn: ['eventType'],
			},
		],
	},
	exclusionAutoReplies: {
		label: 'Exclude AutoReplies',
		required: true,
		type: 'select',
		name: 'exclusionAutoReplies',
		create: true,
		isMulti: true,
		promptMessage: 'Add exclusion autoreplies',
		placeholder: 'All exclusion autoreplies',
		modalMeta: [
			{
				name: 'exclusionAutoReplies',
				label: 'exclusion autoreplies',
				type: 'monaco-editor',
				required: true,
				lang: 'html',
				dependsOn: ['eventType'],
			},
		],
	},
	aliastoemail: {
		label: 'AliasToEmail',
		name: 'aliastoemail',
		type: 'jsonText',
		required: false,
	},
	timeOut: {
		label: 'TimeOut',
		name: 'timeOut',
		type: 'text',
		default: '30000',
		placeholder: 'Please enter TimeOut ,Default is 30000 ms. Min 5000 ms.',
		required: false,
	},
	// delimiter: { label: 'Delimiter', name: 'delimiter', type: 'text', required: false, default: ',', placeholder: "Default is ' , '" },
	// cronPattern: {
	// 	label: 'CronPattern',
	// 	name: 'cronPattern',
	// 	type: 'text',
	// 	default: '*/1 * * * *',
	// 	required: false,
	// 	placeholder: 'Please enter Cron Pattern for Scheduler',
	// 	regexPattern: '\\*\\/\\d{1,2} \\* \\* \\* \\*',
	// 	error: 'Not a valid cron pattern. Please enter */d * * * * with spaces between *s',
	// },
	// originalContentSplitter: {
	// 	label: 'OriginalContentSplitter',
	// 	name: 'originalContentSplitter',
	// 	type: 'text',
	// 	required: false,
	// 	default: 'appendonsend',
	// 	placeholder: 'Please enter content splitter',
	// },
	// exclusionSubject: {
	// 	label: 'ExclusionSubject',
	// 	name: 'exclusionSubject',
	// 	type: 'text',
	// 	default: '/^((?!autoreply|ooo).)*$/g',
	// 	required: false,
	// 	placeholder: 'Please enter Exclusion Subject to filter emails',
	// },
}

const actionsMeta = {
	editItem: {
		type: 'button',
		label: 'Update',
		action: 'editItem',
		name: 'editItem',
	},
	cancel: {
		type: 'button',
		label: 'Cancel',
		action: 'cancelEdit',
		name: 'cancel',
	},
	upsert: {
		label: 'Update',
		name: 'update',
		action: 'upsertItem',
		classes: 'fa fa-pencil fa-lg ',
		type: 'span',
	},
	update: {
		label: 'Edit',
		name: 'update',
		action: 'updateItem',
		classes: 'fa fa-pencil fa-lg ',
		type: 'span',
	},
	list: {
		label: 'List All',
		name: 'list',
		action: 'load',
	},
	search: {
		label: 'Search',
		name: 'search',
		action: 'search',
	},
	view: {
		label: 'View',
		name: 'view',
		action: 'getItem',
		classes: 'fa fa-eye fa-lg',
		type: 'span',
	},
	create: {
		label: 'Create',
		action: 'addNewItem',
		name: 'create',
		type: 'button',
	},
	createItem: {
		label: 'Publish',
		action: 'publishItem',
		name: 'create',
		type: 'button',
	},
	testConnectionItem: {
		label: 'Test Connection',
		action: 'testConnection',
		name: 'create',
		type: 'button',
	},
	createDraft: {
		label: 'Save as Draft',
		action: 'upsertItem',
		name: 'createDraft',
		type: 'button',
	},
	deleteConfig: {
		label: 'Delete',
		action: 'editItem',
		name: 'deleteConfig',
		color: 'danger',
		type: 'button',
	},
}
const sectionsMeta = {
	basic: {
		title: 'Mail Server Details',
		items: [
			{ name: 'protocol', type: 'field' },
			{ name: 'hostName', type: 'field' },
			{ name: 'portNo', type: 'field' },
			{ name: 'failedFolder', type: 'field' },
			{ name: 'allowedDomains', type: 'field' },
			{ name: 'multiItem', type: 'field' },
			// { name: 'reProcessFolder', type: 'field' },
			// { name: 'successFolder', type: 'field' },
			{ name: 'folderMapping', type: 'field' },
			{ name: 'caseFieldsMapping', type: 'field' },
			{ name: 'priorityMapping', type: 'field' },			
			// { name: 'team', type: 'field' },
			// { name: 'domain', type: 'field' },
			// { name: 'category', type: 'field' },
			// { name: 'subCategory', type: 'field' },
			{ name: 'moveToState', type: 'field' },
			// { name: 'exclusionFolder', type: 'field' },
			{ name: 'queueName', type: 'field' },
			{ name: 'username', type: 'field' },
			{ name: 'authType', type: 'field' },
			{ name: 'password', type: 'field' },
			{ name: 'redirectUri', type: 'field' },
			{ name: 'clientId', type: 'field' },
			{ name: 'clientSecret', type: 'field' },
			{ name: 'refreshToken', type: 'field' },
			{ name: 'tenantId', type: 'field' },
			{ name: 'maxTryTicks', type: 'field' },
			{ name: 'skipTicks', type: 'field' },
			{ name: 'delimiter', type: 'field' },
			{ name: 'cronPattern', type: 'field' },
			{ name: 'timeOut', type: 'field' },
			{ name: 'exclusionSubject', type: 'field' },
			{ name: 'originalContentSplitter', type: 'field' },
			{ name: 'aliastoemail', type: 'field' },
			{ name: 'exclusionAutoReplies', type: 'field' },
		],
		classes: 'ticket-form',
	},
	basicUpdate: {
		title: 'Mail Server Details',
		items: [
			{ name: 'protocol', type: 'field' },
			{ name: 'hostName', type: 'field' },
			{ name: 'portNo', type: 'field' },
			{ name: 'failedFolder', type: 'field' },
			{ name: 'allowedDomains', type: 'field' },
			{ name: 'multiItem', type: 'field' },
			// { name: 'reProcessFolder', type: 'field' },
			// { name: 'successFolder', type: 'field' },
			{ name: 'folderMapping', type: 'field' },
			{ name: 'caseFieldsMapping', type: 'field' },
			{ name: 'priorityMapping', type: 'field' },			
			// { name: 'team', type: 'field' },
			// { name: 'domain', type: 'field' },
			// { name: 'category', type: 'field' },
			// { name: 'subCategory', type: 'field' },
			{ name: 'moveToState', type: 'field' },
			// { name: 'exclusionFolder', type: 'field' },
			{ name: 'queueName', type: 'field' },
			{ name: 'usernameUpdate', type: 'field' },
			{ name: 'authType', type: 'field' },
			{ name: 'password', type: 'field' },
			{ name: 'redirectUri', type: 'field' },
			{ name: 'clientId', type: 'field' },
			{ name: 'clientSecret', type: 'field' },
			{ name: 'refreshToken', type: 'field' },
			{ name: 'tenantId', type: 'field' },
			{ name: 'maxTryTicks', type: 'field' },
			{ name: 'skipTicks', type: 'field' },
			{ name: 'delimiter', type: 'field' },
			{ name: 'cronPattern', type: 'field' },
			{ name: 'timeOut', type: 'field' },
			{ name: 'exclusionSubject', type: 'field' },
			{ name: 'originalContentSplitter', type: 'field' },
			{ name: 'aliastoemail', type: 'field' },
			{ name: 'exclusionAutoReplies', type: 'field' },
		],
		classes: 'ticket-form',
	},

	headerComponent: {
		component: 'DetailHeader',
	},
	mailServerForm: {
		cols: [7, 5],
		items: [
			{ name: 'basicUpdate', type: 'section', col: 1 },
			{ name: 'deleteConfig', type: 'action', col: 1 },
			{ name: 'testConnectionItem', type: 'action', col: 1 },
			{ name: 'createItem', type: 'action', col: 1 },
			{ name: 'createDraft', type: 'action', col: 1 },
		],

		classes: 'composite-inner-form',
	},

	mailServerCreateForm: {
		cols: [7, 5],
		items: [
			{ name: 'basic', type: 'section', col: 1 },
			{ name: 'testConnectionItem', type: 'action', col: 1 },
			{ name: 'createItem', type: 'action', col: 1 },
			{ name: 'createDraft', type: 'action', col: 1 },
		],
		classes: 'composite-inner-form',
	},

	mailServerEditForm: {
		cols: [7, 5],
		items: [
			{ name: 'basic', type: 'section', col: 1 },
			{ name: 'createItem', type: 'action', col: 1 },
			{ name: 'createDraft', type: 'action', col: 1 },
		],
		classes: 'composite-inner-form',
	},
}

const screens = {
	view: {
		items: [
			{ name: 'headerComponent', type: 'section' },
			{ name: 'mailServerForm', type: 'section' },
		],
		title: 'Mail Server Details',
	},
	create: {
		items: [
			{ name: 'headerComponent', type: 'section' },
			{ name: 'mailServerCreateForm', type: 'section' },
		],
	},
	edit: {
		items: [
			{ name: 'headerComponent', type: 'section' },
			{ name: 'mailServerEditForm', type: 'section' },
		],
	},
	list: {
		items: [
			{ name: 'protocol', type: 'link' },
			{ name: 'hostName', type: 'field' },
			{ name: 'username', type: 'field' },
			{ name: 'queueName', type: 'field' },
			{ name: 'status', type: 'field' },
		],
		filter: [
			{
				name: 'status',
				operator: 'eq',
				value: 'Published',
				cond: 'or',
			},
			{
				name: 'status',
				operator: 'eq',
				value: 'Draft',
				cond: 'or',
			}
		],
		orderBy: ['createdAt desc'],
		multiselect: false,
	},
}
// @ts-ignore
const mailServer = new mailServerEntity({
	ActionClass: mailServerAction,
	fieldsMeta,
	actionsMeta,
	sectionsMeta,
	propFields: actionsMeta,
	tabsMeta: {},
	screens,
	name: 'Mail Server',
	title: 'Mail Server',
	idKey: 'id',
	methodSchemas,
	collectionSchemas,
	entitySchema,
	entityUrlPaths: { update: 'ticketing/EmailServerConfig/update', default: 'ticketing/EmailServerConfig', publish: 'ticketing/EmailServerConfig/publish', testConnection: 'ticketing/EmailServerConfig/testConnection' },
	fetchDetailByApi: false,
})

const MailServerListSearchContainer = mailServer.getContainer('ListSearch')
const MailServerCreateContainer = mailServer.getContainer('Create')
const MailServerDetailContainer = mailServer.getContainer('Detail')

export { MailServerListSearchContainer, MailServerCreateContainer, MailServerDetailContainer }

